
export const mockItems = [
  {
    id: '1',
    title: 'Elegant Pearl Necklace',
    description: 'Beautiful freshwater pearl necklace with sterling silver clasp',
    category: 'Beauty',
    dateAdded: '2024-01-15',
    image: 'https://public.readdy.ai/ai/img_res/0db600b7365c309475fd5919a071a45e.jpg',
    tags: ['jewelry', 'pearls', 'elegant', 'romantic'],
    isFavorite: true,
    notes: 'I love pearls, they are classic and timeless',
    price: '$189.99',
    priority: 'high'
  },
  {
    id: '2',
    title: 'Silk Scarf Collection',
    description: 'Set of 3 luxury silk scarves in beautiful patterns',
    category: 'Clothing',
    dateAdded: '2024-01-20',
    image: 'https://readdy.ai/api/search-image?query=luxury%20silk%20scarves%20collection%20with%20beautiful%20patterns%20on%20Christmas%20background%20with%20pine%20branches%20and%20ornaments%2C%20fashion%20accessories%20gift%2C%20elegant%20styling%2C%20soft%20lighting&width=400&height=300&seq=2&orientation=landscape',
    tags: ['silk', 'fashion', 'accessories', 'luxury'],
    isFavorite: true,
    notes: 'Perfect for my work outfits, I love wearing scarves',
    price: '$129.99',
    priority: 'medium'
  },
  {
    id: '3',
    title: 'Aromatherapy Diffuser Set',
    description: 'Essential oil diffuser with premium oil collection',
    category: 'Home',
    dateAdded: '2024-01-25',
    image: 'https://readdy.ai/api/search-image?query=elegant%20aromatherapy%20essential%20oil%20diffuser%20with%20premium%20oils%20on%20Christmas%20background%20with%20candles%20and%20holiday%20decorations%2C%20wellness%20gift%2C%20spa%20atmosphere%2C%20warm%20festive%20lighting&width=400&height=300&seq=3&orientation=landscape',
    tags: ['aromatherapy', 'wellness', 'relaxation', 'essential oils'],
    isFavorite: false,
    notes: 'I love relaxing at home, this would be perfect for stress relief',
    price: '$89.99',
    priority: 'medium'
  },
  {
    id: '4',
    title: 'Yoga Mat & Accessories',
    description: 'Premium yoga mat with blocks, strap, and carrying bag',
    category: 'Sports',
    dateAdded: '2024-02-01',
    image: 'https://readdy.ai/api/search-image?query=premium%20yoga%20mat%20with%20blocks%20and%20strap%20in%20elegant%20purple%20color%20on%20Christmas%20background%2C%20fitness%20gift%2C%20health%20and%20wellness%2C%20holiday%20sports%20equipment%2C%20festive%20lighting&width=400&height=300&seq=4&orientation=landscape',
    tags: ['yoga', 'fitness', 'wellness', 'purple'],
    isFavorite: true,
    notes: 'I just started yoga classes, purple is my favorite color',
    price: '$79.99',
    priority: 'high'
  },
  {
    id: '5',
    title: 'Gourmet Tea Collection',
    description: 'Premium loose leaf tea sampler with beautiful packaging',
    category: 'Food',
    dateAdded: '2024-02-05',
    image: 'https://readdy.ai/api/search-image?query=premium%20loose%20leaf%20tea%20collection%20with%20elegant%20packaging%20on%20Christmas%20background%20with%20red%20ribbons%20and%20ornaments%2C%20gourmet%20food%20gift%2C%20tea%20ceremony%2C%20warm%20festive%20atmosphere&width=400&height=300&seq=5&orientation=landscape',
    tags: ['tea', 'gourmet', 'relaxation', 'premium'],
    isFavorite: false,
    notes: 'I drink tea every evening, love trying new flavors',
    price: '$65.99',
    priority: 'low'
  },
  {
    id: '6',
    title: 'Cashmere Throw Blanket',
    description: 'Ultra-soft cashmere throw in cream color',
    category: 'Home',
    dateAdded: '2024-02-10',
    image: 'https://readdy.ai/api/search-image?query=luxury%20cashmere%20throw%20blanket%20in%20cream%20color%20on%20Christmas%20background%20with%20gold%20and%20red%20decorations%2C%20cozy%20home%20gift%2C%20bedroom%20accessories%2C%20holiday%20home%20decor%2C%20elegant%20lighting&width=400&height=300&seq=6&orientation=landscape',
    tags: ['cashmere', 'luxury', 'cozy', 'cream'],
    isFavorite: true,
    notes: 'Perfect for movie nights, I love soft textures',
    price: '$159.99',
    priority: 'medium'
  },
  {
    id: '7',
    title: 'Kindle Paperwhite',
    description: 'Latest Kindle with adjustable warm light',
    category: 'Electronics',
    dateAdded: '2024-02-12',
    image: 'https://readdy.ai/api/search-image?query=Amazon%20Kindle%20Paperwhite%20e-reader%20on%20Christmas%20background%20with%20books%20and%20holiday%20decorations%2C%20reading%20gift%2C%20tech%20gadget%20for%20book%20lovers%2C%20warm%20festive%20lighting&width=400&height=300&seq=7&orientation=landscape',
    tags: ['kindle', 'reading', 'books', 'technology'],
    isFavorite: false,
    notes: 'I read every night, would love the convenience',
    price: '$139.99',
    priority: 'medium'
  },
  {
    id: '8',
    title: 'Artisan Chocolate Box',
    description: 'Handcrafted chocolates from local chocolatier',
    category: 'Food',
    dateAdded: '2024-02-15',
    image: 'https://readdy.ai/api/search-image?query=luxury%20artisan%20chocolate%20box%20with%20handcrafted%20chocolates%20on%20Christmas%20background%20with%20golden%20ribbons%20and%20ornaments%2C%20gourmet%20food%20gift%2C%20romantic%20present%2C%20warm%20festive%20lighting&width=400&height=300&seq=8&orientation=landscape',
    tags: ['chocolate', 'artisan', 'gourmet', 'sweet'],
    isFavorite: true,
    notes: 'My favorite treat, especially dark chocolate',
    price: '$45.99',
    priority: 'high'
  }
];

export const categories = [
  'All',
  'Electronics',
  'Clothing',
  'Books',
  'Sports',
  'Food',
  'Home',
  'Beauty',
  'Toys',
  'Games'
];